/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { defineMessages } from 'react-intl';

export const Voice = defineMessages({
  createdSttInstance: {
    id: 'channels.voice.speechToText.created',
    defaultMessage: 'Successfully created Speech To Text instance'
  },
  sttInstanceNotFound: {
    id: 'channels.voice.speechToText.notFound',
    defaultMessage:
      'Configured Speech to Text instance not found, a new one has been selected.'
  },
  createdTtsInstance: {
    id: 'channels.voice.textToSpeech.created',
    defaultMessage: 'Successfully created Text to Speech instance'
  },
  ttsInstanceNotFound: {
    id: 'channels.voice.textoToSpeech.notFound',
    defaultMessage:
      'Configured Text to Speech instance not found, a new one has been selected.'
  },
  credentialCreationFailed: {
    id: 'channels.voice.createCredentials.failed',
    defaultMessage: 'Failed to create credentials for instance. Try again.'
  },
  notActive: {
    id: 'channels.voice.configuredInstanceInactive',
    defaultMessage: 'Configured instance is not active: {instanceId}'
  },
  badInstanceId: {
    id: 'channels.voice.badInstanceId',
    defaultMessage: 'Loaded instanceId is not a CRN: {instanceId}'
  },
  statusCreating: {
    id: 'phone.Speech.statusCreating',
    defaultMessage: 'Creating...'
  },
  statusSuccess: {
    id: 'phone.Speech.statusSuccess',
    defaultMessage: 'Success'
  },
  statusFailed: {
    id: 'phone.Speech.statusFailed',
    defaultMessage: 'Failed'
  }
});
